import { useEffect, useRef, useState } from "react";
import { isEmpty, map, noop } from "lodash";
import PropTypes from "prop-types";
import cn from "../../../utils/cn";
import Menu from "./Menu";
import filterChildren from "../../utils/Children/filterChildren";
import { RETURN_KEY_CODE } from "../../../utils/Browser/keyCodes";
import { isKeyPressed } from "../../../utils/isKeyPressed";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const MenuItem = _ref => {
  let {
    id = "",
    className = "",
    primaryNode = [],
    index = null,
    position = 0,
    children = [],
    menuItems = [],
    subMenuPosition = "left-start",
    subMenuTarget = "top-bottom",
    onKeyDown = noop,
    handleMenuItemNavigation = noop,
    subItemParent = false,
    closeMainMenu = noop,
    onClick = noop,
    handleParentMenuonClick = noop,
    setPosition = noop,
    togglePopover = noop
  } = _ref;
  const menuItemDOM = useRef(null);
  useEffect(() => {
    if (position === index && menuItemDOM.current) {
      menuItemDOM.current.focus();
    }
  }, [position, index]);
  const handleClick = () => {
    onClick();
    if (menuItemDOM.current) {
      menuItemDOM.current.blur();
    }
    if (isEmpty(menuItems) && onClick !== noop) {
      togglePopover();
    }
    if (subItemParent) {
      closeMainMenu();
    }
    handleParentMenuonClick();
  };
  const handleKeyDown = e => {
    onKeyDown(e);
    handleMenuItemNavigation(e);
  };
  const menuItemClass = cn({
    "font-regular-font items-center cursor-pointer flex p-4 text-sm hover:font-semibold border-l-4 border-transparent": true,
    'hover:border-action-blue hover:bg-medium-fill-blue': index === position,
    "cursor-default": onClick === noop && isEmpty(menuItems)
  }, className);
  const submenuItemClass = cn({
    "w-full": true,
    "bg-medium-fill-blue": index === position
  });
  const newChildren = filterChildren(children);
  if (!isEmpty(menuItems)) {
    return /*#__PURE__*/_jsx(Menu, {
      className: submenuItemClass,
      anchorElement: /*#__PURE__*/_jsxs("div", {
        id: id,
        role: "button",
        tabIndex: 0,
        className: menuItemClass,
        onClick: handleParentMenuonClick,
        onKeyDown: handleKeyDown,
        onMouseEnter: () => setPosition(index),
        ref: menuItemDOM,
        children: [primaryNode, newChildren]
      }),
      position: subMenuPosition,
      target: subMenuTarget,
      subItemParent: true,
      closeMainMenu: togglePopover,
      children: map(menuItems, menuItem => menuItem)
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    id: id,
    role: "button",
    tabIndex: 0,
    className: menuItemClass,
    onClick: handleClick,
    onKeyDown: e => {
      if (isKeyPressed(e, "Enter", RETURN_KEY_CODE)) {
        togglePopover();
        if (subItemParent) {
          closeMainMenu();
        }
      }
      onKeyDown(e);
      handleMenuItemNavigation(e);
    },
    onMouseEnter: () => setPosition(index),
    ref: menuItemDOM,
    children: [primaryNode, children]
  });
};
MenuItem.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  primaryNode: PropTypes.node,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  handleMenuItemNavigation: PropTypes.func,
  handleParentMenuonClick: PropTypes.func,
  menuItems: PropTypes.array,
  subMenuPosition: PropTypes.oneOf(["right-start", "right-end", "left-start", "left-end", "bottom-start", "bottom-end", "top-start", "top-end"]),
  subMenuTarget: PropTypes.oneOf(["top-bottom", "bottom-top", "right-left", "left-right"]),
  subItemParent: PropTypes.bool,
  setPosition: PropTypes.func,
  position: PropTypes.number,
  togglePopover: PropTypes.func,
  closeMainMenu: PropTypes.func,
  index: PropTypes.number,
  children: PropTypes.node.isRequired
};
export default MenuItem;
//# sourceMappingURL=MenuItem.js.map